const initialState = 1;

const accountsPaginationReducer = (state = initialState, action) => {
      switch (action.type) {
            case 'SET_SELECTED_ACCOUNTS_PAGE':
                  return action.pageNumber;
            case 'LOGOUT_USER':
                  return 1;
            default:
                  break;
      }
      return state;
};
export default accountsPaginationReducer;